export default "__VITE_ASSET__DvjsCnIw__"